import { visitorClient } from '#pplx_generated/typespec/rest/visitor/client.js';
export async function getVisitorConsentRequirementFromBackend() {
    const { error, data } = await visitorClient.GET('/rest/visitor/consent-requirement', 'gdpr-consent-mode', { timeoutMs: 1500 });
    if (error || !data) {
        throw new Error('Failed to fetch GDPR consent requirement');
    }
    return data;
}
export async function getTrackingPolicyFromBackend() {
    return (await getVisitorConsentRequirementFromBackend()).tracking_policy;
}
//# sourceMappingURL=gdprUtils.js.map